import { gql } from '@apollo/client';

const INIT_DRAFT_CHECKPOINT = gql`
  mutation InitDraftCheckPoint($orgUnitId: Int!, $appraisalId: Int!) {
    initDraftCheckPoint(orgUnitId: $orgUnitId, appraisalId: $appraisalId)
  }
`;

export default INIT_DRAFT_CHECKPOINT;
